import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import { ORDER_REQUIRED_FIELDS, SALES_REP_FILTER_RULES } from '../shared';

/**
 * Requires Attention list configuration
 * Orders from CRM or E-Commerce that need attention: orders with 'Held' or 'Approval Required' status, OR orders with alert errors
 */
export const requiresAttentionList: ListBuilderList = {
	id: 'requires-attention',
	cacheTTL: 600000,
	name: 'Requires Attention',
	type: 'default',
	active: true,
	sortOrder: 2,
	requiredFeature: 'order-entry',
	columns: createStandardOrderColumns(),
	description:
		"Orders from CRM or E-Commerce that need attention: orders with 'Held' or 'Approval Required' status, OR orders with alert errors",
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderOrigin: {
			defaultValue: [
				{
					id: '1',
					label: 'CRM',
				},
				{
					id: '3',
					label: 'E-Commerce',
				},
			],
		},
		orderStatus: {
			defaultValue: [
				{
					id: 'requires-attention',
					data: {
						id: 'requires-attention',
						label: 'Requires Attention',
					},
					label: 'Requires Attention',
				},
			],
		},
	},
};
